var map = {
	"./INAB/reviewandapproval": [
		81973,
		1192,
		2019,
		9199,
		2954,
		5786,
		5454,
		5049,
		5150,
		4065,
		9691,
		4774,
		1373,
		2350,
		5909
	],
	"./INABTailwind/reviewandapproval": [
		33813,
		2019,
		9199,
		2954,
		5786,
		5454,
		1966,
		4679,
		1373,
		4748,
		493
	],
	"./dealreview/reviewandapproval": [
		15499,
		1192,
		2019,
		9199,
		5049,
		5073,
		4065,
		9691,
		4774,
		9960,
		1428,
		5499
	],
	"./dealreviewTailwindUI/reviewandapproval": [
		39226,
		1192,
		2019,
		9199,
		2954,
		4201,
		7417,
		1207,
		1823
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36925;
module.exports = webpackAsyncContext;